import { useEffect, useState } from 'react';

export const LIGHT_MODE = 'light';
export const DARK_MODE = 'dark';

type Modes = typeof LIGHT_MODE | typeof DARK_MODE;

export const useThemeMode = () => {
  const [mode, setMode] = useState<Modes>(LIGHT_MODE);

  useEffect(() => {
    const themeMode = window.matchMedia('(prefers-color-scheme: dark)');
    setMode(themeMode.matches ? DARK_MODE : LIGHT_MODE);

    const eventHandler = (ev: MediaQueryListEvent) => setMode(ev.matches ? DARK_MODE : LIGHT_MODE);
    themeMode.addEventListener('change', eventHandler);

    return () => themeMode.removeEventListener('change', eventHandler);
  }, []);

  return { mode };
};